import React from 'react';
import { motion } from 'framer-motion';
export function StickyAlertBar() {
  return <motion.div initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="sticky top-0 z-50 w-full bg-urgency text-white py-3 px-4 text-center shadow-lg" data-id="element-203">
      <p className="font-montserrat font-bold text-sm md:text-base" data-id="element-204">
        🔥 OFERTA ESPECIAL: 60% DE DESCUENTO - ¡Solo quedan 7 copias en
        promoción!
      </p>
    </motion.div>;
}